var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1Wave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 344,
    viewBox: "0 0 1440 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.4086L27 11.3953C53 3.382 107 -13.217 160 19.4086C213 52.6066 229 88.3779 308 95.5115C387 102.645 421.5 95.5115 494.5 73.7143C567.5 51.9171 588.537 44.3858 640 34.083C691.463 23.7801 755 9.03555 822.502 19.4086C890.004 29.7817 916 40.9251 969 61.5308C1022 82.1364 1079 95.5115 1129.5 95.5115C1180 95.5115 1216 91.0907 1270.5 67.5408C1325 43.9908 1334.5 36.1122 1367.5 27.7604C1400.5 19.4086 1440 27.7604 1440 27.7604V344H1413C1387 344 1333 344 1280 344C1227 344 1173 344 1120 344C1067 344 1013 344 960 344C907 344 853 344 800 344C747 344 693 344 640 344C587 344 533 344 480 344C427 344 373 344 320 344C267 344 213 344 160 344C107 344 53 344 27 344H0V19.4086Z",
    fill: "url(#paint0_linear_611_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_611_5",
    x1: 720,
    y1: 285,
    x2: 720,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CCCC",
    stopOpacity: 0.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Wave);
export default __webpack_public_path__ + "static/media/1wave.f97c6c5b42092ab6b3a0213f0f518ff6.svg";
export { ForwardRef as ReactComponent };